import {
  Button,
  Col,
  Form,
  message,
  Row,
  Select,
  Input,
  DatePicker,
} from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { StockStatuses } from "_helpers";
import {
  companyService,
  materialDetailService,
  materialTypeService,
  binService,
  storageUnitService,
  stockClassificationService,
} from "_services";

function MaterailDetailSearch(props) {
  const [form] = Form.useForm();
  const [addressLoading, setAddressLoading] = useState(false);
  const [isLoadingStockTypes, setIsLoadingStockTypes] = useState(false);
  const [isLoadingStockBins, setIsLoadingStockBins] = useState(false);
  const [isLoadingStockClassifications, setIsLoadingStockClassifications] =
    useState(false);
  const [addresses, setAddresses] = useState([]);
  const [storeBins, setStoreBins] = useState([]);
  const [stockTypes, setStockTypes] = useState([]);
  const [stockClasses, setStockClasses] = useState([]);

  useEffect(() => {
    getStoreAddresses();
    getMaterialTypes();
    getStockBins();
    getStockClassifications();
  }, []);

  const getStoreAddresses = () => {
    setAddressLoading(true);
    companyService
      .getSuggestion("?companyTypeCodes=STORE")
      .then((x) => {
        setAddressLoading(false);
        if (x.content && x.content.length === 1) {
          setAddressLoading(true);
          companyService
            .getById(x.content[0].id)
            .then((x) => {
              setAddressLoading(false);
              setAddresses(x.content.addresses);
              if (x.content.addresses.length === 1) {
                form.setFieldsValue({
                  storeLocationIdStr: x.content.addresses[0].id,
                });
              }
            })
            .catch((errorInfo) => {
              setAddressLoading(false);
            });
        }
      })
      .catch((errorInfo) => {
        setAddressLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getMaterialTypes = () => {
    setIsLoadingStockTypes(true);
    materialTypeService
      .getSuggestion()
      .then((x) => {
        setIsLoadingStockTypes(false);
        setStockTypes(x.content);
      })
      .catch((error) => {
        setIsLoadingStockTypes(false);
        message.error(`${error}`);
      });
  };

  const getStockBins = () => {
    setIsLoadingStockBins(true);
    binService
      .getSuggestion("")
      .then((y) => {
        setIsLoadingStockBins(false);
        setStoreBins(y.content);
      })
      .catch((error) => {
        setIsLoadingStockBins(false);
        message.error(`${error}`);
      });
  };

  const getStockClassifications = () => {
    setIsLoadingStockClassifications(true);
    stockClassificationService
      .getSuggestion()
      .then((x) => {
        setIsLoadingStockClassifications(false);
        setStockClasses(x.content);
      })
      .catch((errorInfo) => {
        setIsLoadingStockClassifications(false);
        message.error(`${errorInfo}`);
      });
  };

  const onFinish = (values) => {
    props.showSearchLoading(true);
    let searchParams = "";
    if (values.stockTypeIdStr) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `stockTypeIdStr=${encodeURIComponent(
        values.stockTypeIdStr
      )}`;
    }
    if (values.storeLocationIdStr) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `storeLocationIdStr=${encodeURIComponent(
        values.storeLocationIdStr
      )}`;
    }
    if (values.receiptNumber) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `receiptNumber=${encodeURIComponent(
        values.receiptNumber
      )}`;
    }
    if (values.modes) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `modes=${encodeURIComponent(values.modes)}`;
    }
    if (values.stockBinId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `stockBinIdStr=${encodeURIComponent(values.stockBinId)}`;
    }
    if (values.stockClassificationIdStr) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `stockClassificationIdStr=${encodeURIComponent(
        values.stockClassificationIdStr
      )}`;
    }
    if (values.receivedDateRange) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `fromReceivedDate=${encodeURIComponent(
        moment(values.receivedDateRange[0]).startOf("day").format("YYYY-MM-DD")
      )}&toReceivedDate=${moment(values.receivedDateRange[1])
        .startOf("day")
        .format("YYYY-MM-DD")}`;
    }
    if (values.poNumber) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `poNumber=${encodeURIComponent(values.poNumber)}`;
    }
    storageUnitService
      .search(searchParams)
      .then((data) => {
        props.onSearchResults(data.content, data.pagination, searchParams);
      })
      .catch((error) => {
        message.error(`${error}`);
        props.onSearchResults([]);
      });
  };

  const onClear = () => {
    props.onSearchResults([], { totalRecords: 0, totalGross: [] }, "");
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
    >
      <Row gutter={24}>
        <Col span={5}>
          <Form.Item name="receiptNumber" label="Receipt Number">
            <Input placeholder="Receipt Number" allowClear={true} />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="storeLocationIdStr" label="Store Location">
            <Select
              placeholder="Please select"
              allowClear
              loading={addressLoading}
            >
              {addresses.length > 0 &&
                addresses.map((t) => (
                  <Select.Option value={t.id} key={t.id}>
                    {t.address}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="receivedDateRange" label="Received Date">
            <DatePicker.RangePicker
              ranges={{
                Today: [moment(), moment()],
                "This Month": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
              }}
            />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="modes" label="Status">
            <Select
              showSearch
              allowClear
              showArrow={false}
              optionFilterProp="children"
              placeholder="Please select"
              mode="multiple"
            >
              {StockStatuses.map((t) => (
                <Select.Option value={t.value} key={t.value}>
                  {t.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4} style={{ textAlign: "right" }}>
          <div>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                //onFinish({});
                onClear();
              }}
            >
              Clear
            </Button>
          </div>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={5}>
          <Form.Item name="stockTypeIdStr" label="Material Type">
            <Select
              showSearch
              allowClear
              showArrow={true}
              optionFilterProp="children"
              placeholder="Material Type"
              loading={isLoadingStockTypes}
            >
              {stockTypes.map((t) => (
                <Select.Option value={t.id} key={t.id}>
                  {t.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="stockBinIdStr" label="Stock Bin">
            <Select
              showSearch
              allowClear
              showArrow={true}
              optionFilterProp="children"
              placeholder="Bin"
              loading={isLoadingStockBins}
            >
              {storeBins.map((t) => (
                <Select.Option value={t.id} key={t.id}>
                  {t.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="stockClassificationIdStr" label="Stock Category">
            <Select
              placeholder="Please select"
              allowClear
              loading={isLoadingStockClassifications}
            >
              {stockClasses.length > 0 &&
                stockClasses.map((t) => (
                  <Select.Option value={t.id} key={t.id}>
                    {t.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="poNumber" label="PO Number">
            <Input rows={1} placeholder="Order No" allowClear={true} />
          </Form.Item>
        </Col>
        <Col span={4}></Col>
      </Row>
    </Form>
  );
}

export default MaterailDetailSearch;
